import React from 'react';

import * as model from 'models';

interface IUserDtoProps {
    value: model.UserDto;
}

export default function UserDtoView(props: IUserDtoProps) {
    let value = props.value;
    return <><span title={value.email}>{value.fullName}</span></>
}

